import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { saveEmployerEmployeeRelationshipBO } from './client-employee-relationship.modal';

@Injectable({
  providedIn: 'root'
})
export class ClientEmployeeRelationshipService {

  constructor(private http: HttpClient, public errorService: ErrorService) {

  }

  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  
  GetRelationshipDropdown(): Observable<any> {
    let url = "api/Relationship/GetRelationshipDropdown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  SaveEERelationship(saveR: saveEmployerEmployeeRelationshipBO): Observable<any> {
    let url = "api/EmployerEmployeeRelationship/SaveEERelationship";
    return this.http.post(url, saveR, { observe: 'response',responseType: "text"},).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
}
 
  GetEmployeeDropDown(): Observable<any> {
    let url = "api/Employee/EmployeeDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetClientDropdown(): Observable<any> {
    let url = "api/Client/clientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetEERelationshipwithTax(paramsData: URLSearchParams): Observable<any> {
    let url = "api/EmployerEmployeeRelationship/GetEERelationshipwithTax?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  
  GetAllTaxes(): Observable<any> {
    let url = "api/Tax/GetAllTaxes?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}


